import MultiSelectDropdown, { SingleSelectProps } from "./MultiSelectDropdown";

const SingleSelectDropdown = ({ placeholder = "None", ...props }: SingleSelectProps) => (
  // eslint-disable-next-line react/jsx-props-no-spreading
  <MultiSelectDropdown isMulti={false} placeholder={placeholder} closeOnMenuSelect {...props} />
);

export default SingleSelectDropdown;
